export const AuthenticationConstants = {
  token: {
    grant_type: 'password',
    client_id: 'fms-client-web'
  }
};

export const AuthenticationHeaders = {
  UserName: 'username',
  Password: 'password',
  GrantType: 'grant_type',
  ClientId: 'client_id'
};

export const AuthenticationRoutes = {
  Login: () => `/connect/token`,
  UserInfo: () => '/connect/userinfo',
  CaptchVerify: () => '/api/captcha/verify',
  SaveToken: () => `/api/user/savetoken`,
  MFAverify: '/api/user/MFAVerfication',
  verify: '/api/user/verify',
  MFAotpVerify: (guid: string, tokenCode: string,MFA: string,MFARequestType: string) => `/api/user/MFAverify-otp/${guid}/${tokenCode}/${MFA}/${MFARequestType}`,
  otpVerify: (guid: string, tokenCode: string) => `/api/user/verify-otp/${guid}/${tokenCode}`,
};

export const AuthenticationMessages = {
  LoginError: 'Error while logging',
  LoginSuccess: 'Login Successful',
  DecodedToken: 'Decoded Token',
  AuthenticationState: 'Authentication State',
  invalid_username_or_password: 'Invalid UserName or Password'
};

export const AuthenticationErrorCodes = {
  InvalidGrant: 'invalid_grant',
  InvalidUsernameorPassword: 'invalid_username_or_password'
};

export const AuthenticationToken = {
  TokenInfo: 'tokenInfo'
};

export const UserRoles = {
  Roles: 'roles'
};
